module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAALCAYAAABLcGxfAAAA1UlEQVQokZXQIS+GURjG8d9jGLMpgiDYBM1ECrPhQ0hGeO5i014fQyGcoAqSYhMUM5tJFPMV2N5EEx677QlPeJn3Sufe/v9z7utUTdOIiBOs4tPgTOK1lLJb1XW9iLNSytov8E8i4hq9ERzi+C+4zSkOUtjE5T+EK6ynUGGsfXY+IvY6a+xHxEI7jiebHXrYwQM28I5+C81gFrdYwcUoHrGEcxzhA8ut8Iypdv7CSwqZfinlrrPvU+ecX30fEds5ZIehMoyQbJOl53CDtwHQdOfSCWx9A1d9MckPN8iLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/ggmd.png
// module id = AxId
// module chunks = 1